import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames";
import { trade } from "../placeholder";
import Search from "../components/Search";
import { useDispatch } from "react-redux";
import { tradeBorrow, tradeLend } from "../redux/actions/modal";
import Hint from "../components/Hint/Hint";
import { Web3Context } from "../contexts/Web3Context";
import * as lendApi from "../apis/lendApi";
import * as blockchainApi from "../apis/blockchain";
import { removeDecimal } from "../apis/utils";
import coinLogos from "../assets/images/currency-icons/coinLogos.js";
import { BigNumber, ethers } from "ethers";
import ship from "../assets/images/ship.png";
import InfoButton from "../partials/Form/InfoButton";
import InfoButtonMobile from "../partials/Form/InfoButtonMobile";

export default function () {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [tradeType, setTradeType] = useState("lend");
  const [list, setList] = useState([]);

  let web3Context = useContext(Web3Context);

  const [state, setState] = useState({
    assetAddresses: [],
    assetContracts: [],
    assetData: [],
    loading: true,
  });

  const setupStates = async () => {
    try {
      const assetAddresses = await blockchainApi.getAssets(
        web3Context.web3.moneyMarketControlContract
      );

      const assetContractPromises = [];

      for (let address of assetAddresses) {
        // instance all asset contracts
        assetContractPromises.push(
          blockchainApi.getAssetContract(web3Context.web3.web3Provider, address)
        );
      }

      const assetContracts = await Promise.all(assetContractPromises);

      console.log(assetContracts);

      const assetData = [];
      let i = 0;
      for (let asset of assetContracts) {
        if (i != 10) {
          let mmi = await blockchainApi.getMoneyMarketInstanceContract(
            web3Context.web3.moneyMarketControlContract,
            asset.address,
            web3Context.web3.web3Provider
          );

          let [alr, ahr, collateralLockedALR] = await Promise.all([
            blockchainApi.getARTContract(
              await mmi.ALR(),
              web3Context.web3.web3Provider
            ),
            blockchainApi.getARTContract(
              await mmi.AHR(),
              web3Context.web3.web3Provider
            ),
            mmi.collateralLockedALR(web3Context.currentAccountAddress),
          ]);

          //console.log(ahr)

          let [alrBalance, ahrBalance, tier, collateralLockedContract] =
            await Promise.all([
              lendApi.getSuppliedBalance(
                alr,
                web3Context.currentAccountAddress
              ),
              lendApi.getSuppliedBalance(
                ahr,
                web3Context.currentAccountAddress
              ),
              alr.tier(),
              blockchainApi.getARTContract(
                collateralLockedALR,
                web3Context.web3.web3Provider
              ),
            ]);

          let [
            name,
            balance,
            supplyApyAlr,
            supplyApyAhr,
            borrowApy,
            borrowBalance,
            liquidity,
            liquidityLR,
            liquidityHR,
            availableCollateral,
            collatRatio,
            alrBalanceInAsset,
            ahrBalanceInAsset,
            allowance,
          ] = await Promise.all([
            asset.name(),
            blockchainApi.getERC20Balance(
              asset,
              web3Context.currentAccountAddress
            ),
            lendApi.getSupplyApy(alr),
            lendApi.getSupplyApy(ahr),
            lendApi.getBorrowApy(alr, ahr),
            lendApi.getBorrowBalance(
              alr,
              ahr,
              web3Context.currentAccountAddress
            ),
            lendApi.getLiquidity(alr, ahr),
            alr.getCash(),
            ahr.getCash(),
            web3Context.web3.moneyMarketControlContract.viewAvailibleCollateralValue(
              web3Context.currentAccountAddress,
              alr.address
            ),
            mmi.collatRatio(),
            alrBalance,
            ahrBalance,
            asset.allowance(web3Context.currentAccountAddress, mmi.address),
          ]);

          let [collateralValue, usdBorrowBalance] = await Promise.all([
            web3Context.web3.moneyMarketControlContract.checkCollateralizedALR(
              web3Context.currentAccountAddress,
              collateralLockedALR,
              mmi.address
            ),
            web3Context.web3.uniswapOracleFactoryContract.viewUnderlyingPriceofAsset(
              mmi.address,
              borrowBalance
            ),
          ]);

          assetData.push({
            name: name,
            contract: asset,
            balance: balance,
            mmi: mmi,
            alr: alr,
            ahr: ahr,
            alrBalance: alrBalance,
            ahrBalance: ahrBalance,
            supplyApyAlr: supplyApyAlr,
            supplyApyAhr: supplyApyAhr,
            borrowApy: borrowApy,
            borrowBalance: borrowBalance,
            liquidity: liquidity,
            liquidityLR: liquidityLR,
            liquidityHR: liquidityHR,
            index: i,
            availableCollateral: availableCollateral,
            collatRatio: collatRatio,
            alrBalanceInAsset: alrBalanceInAsset,
            ahrBalanceInAsset: ahrBalanceInAsset,
            allowance: allowance,
            tier: parseInt(tier) + 1,
            collateralLockedALR: collateralLockedALR,
            collateralValue: collateralValue,
            usdBorrowBalance: usdBorrowBalance,
            collateralLockedContract: collateralLockedContract,
            isInactive: name === "Wrapped BNB" ? true : false,
            listTable: [
              {
                id: 0,
                type: "Original Collateralization Ratio",
                ratio: collatRatio / 100,
                info: "The collateral ratio you borrowed at.",
              },
              {
                id: 1,
                type: "Actual Collateralization Ratio",
                ratio:
                  collateralValue != 0
                    ? collateralValue.mul(100).div(usdBorrowBalance).toString()
                    : "0",
                info: "Your current collateral ratio.",
              },
              {
                id: 2,
                type: "Minimum Collateralization Ratio",
                ratio: 130,
                info: "You will have 24 hours to repay/loan Status.",
              },
              {
                id: 3,
                type: "All Collateral Liquidation Collateralization Ratio",
                ratio: 110,
                info: "You will be liquidated instantly.",
              },
            ],
          });
        }
        i++;
      }

      const loading = false;

      setState({
        ...state,
        assetAddresses,
        assetContracts,
        assetData,
        loading,
      });

      console.log(assetData);
      setList(assetData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (web3Context.web3.initialized === true) {
      setupStates();
    }
  }, [web3Context]);

  let data = state.assetData;

  const searchChange = () => {
    // Include debounce or throttle
    const value = search.trim().toLowerCase();
    const currentList = data.filter((asset) =>
      asset.name.toLowerCase().includes(value)
    );

    if (value === "") {
      return setList(data);
    }

    if (currentList.length > 0) {
      return setList(currentList);
    }

    return setList([]);
  };

  useEffect(async () => {
    if (web3Context.web3.initialized === true) {
      searchChange();
    }
  }, [search]);

  return (
    <div className="trade">
      <header className="trade__header">
        <Search
          className="trade__search"
          placeholder="Search by asset name..."
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="trade__controls">
          <button
            className={classNames("trade-controls__btn", {
              active: tradeType === "lend",
            })}
            onClick={setTradeType.bind(null, "lend")}
          >
            Lend
          </button>
          <button
            className={classNames("trade-controls__btn", {
              active: tradeType === "borrow",
            })}
            onClick={setTradeType.bind(null, "borrow")}
          >
            Borrow
          </button>
        </div>
      </header>

      <div>
        {state.loading &&
        web3Context.web3.networkID === 56 &&
        web3Context.currentAccountAddress ? (
          <div className="loading_trade_wrapper">
            <img src={ship} />
            Loading...
          </div>
        ) : state.loading &&
          web3Context.web3.networkID != 56 &&
          web3Context.currentAccountAddress.length > 2 ? (
          <div className="loading_trade_wrapper">
            <img src={ship} />
            Please switch to BSC...
          </div>
        ) : state.loading ? (
          <div className="loading_trade_wrapper">
            <img src={ship} />
            Please connect wallet...
          </div>
        ) : null}
      </div>

      <ul className="trade__list">
        {web3Context.metamaskConnected != false
          ? list.map((asset) => (
              <li
                className={
                  (tradeType === "lend") & asset.isInactive
                    ? "not_active trade-item"
                    : "trade-item"
                }
                key={asset.name}
              >
                <div className="trade-item__star">
                  <Hint
                    className="trade-item__hint"
                    hintContent={
                      asset.tier === 1
                        ? "Category 1 tokens can be used as collateral to borrow category 1, 2, 3 and 4 tokens"
                        : asset.tier === 2
                        ? "Category 2 tokens can be used as collateral to borrow category 2, 3 and 4 tokens"
                        : asset.tier === 3
                        ? "Category 3 tokens can be used as collateral to borrow category 3 and 4 tokens"
                        : asset.tier === 4
                        ? "Category 4 tokens can be used as collateral to borrow category 4 tokens"
                        : null
                    }
                    posY="bottom"
                    posX="left"
                    maxWidth={350}
                    edgeCut={5}
                  >
                    <span>C{asset.tier}</span>
                  </Hint>
                </div>

                <div className="trade-item__header">
                  {/* <a
                    href="https://www.coingecko.com/en"
                    target="_blank"
                    rel="noreffer"
                  > */}
                  <img
                    src={coinLogos[asset.index]}
                    alt="icon"
                    className="trade-item__icon"
                  />
                  {/* </a> */}
                  <h4 className="trade-item__currency">{asset.name}</h4>{" "}
                  {tradeType === "lend" ? (
                    <div className="trade-item__apr">
                      <InfoButton className="r-table__info">
                        AMR "Achievable Market Rate", is an indicative rate
                        established to inform lenders of the target rates after
                        deduction of platform fees, that may or may not be
                        achieved, as it is reliant on supply and demand in a
                        given asset market. AMR does not include additional
                        earnings that lenders and borrowers may generate through
                        the use of the swap and farms services offered within
                        the rASKO Money Market ecosystem.
                      </InfoButton>
                      <InfoButtonMobile
                        text='AMR "Achievable Market Rate", is an indicative rate
                    established to inform lenders of the target rates after
                    deduction of platform fees, that may or may not be achieved,
                    as it is reliant on supply and demand in a given asset
                    market. AMR does not include additional earnings that
                    lenders and borrowers may generate through the use of the
                    swap and farms services offered within the rASKO Money
                    Market ecosystem.'
                      />{" "}
                      &nbsp;
                      <span className="trade-item__info-title">
                        AMR Up To
                      </span>{" "}
                      &nbsp;
                      <span className="trade-item__info-value">0 %</span>
                    </div>
                  ) : null}
                </div>
                {tradeType === "lend" ? (
                  <div className="trade-item__info">
                    <div className="trade-item__col">
                      <span className="trade-item__info-title">APR (LR)</span>
                      <span className="trade-item__info-value">
                        {removeDecimal(
                          ethers.utils.formatEther(asset.supplyApyAlr) * 100
                        ) / (100).toString()}
                        %
                      </span>
                    </div>
                    <div className="trade-item__col">
                      <span className="trade-item__info-title">APR (HR)</span>
                      <span className="trade-item__info-value">
                        {removeDecimal(
                          ethers.utils.formatEther(asset.supplyApyAhr) * 100
                        ) / (100).toString()}
                        %
                      </span>
                    </div>
                    <div className="trade-item__col">
                      <span className="trade-item__info-title">
                        Supplied (LR)
                      </span>
                      <span className="trade-item__info-value">
                        {asset.contract.address !=
                        "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                          ? asset.contract.address !=
                              "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                            asset.contract.address !=
                              "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                            ? removeDecimal(
                                ethers.utils.formatEther(
                                  asset.alrBalanceInAsset
                                ) * 1000
                              ) / (1000).toString()
                            : ethers.utils.formatEther(
                                asset.alrBalanceInAsset
                              ) * (10000000000).toString()
                          : removeDecimal(
                              ethers.utils.formatUnits(
                                asset.alrBalanceInAsset,
                                6
                              ) * 1000
                            ) / (1000).toString()}
                      </span>
                    </div>
                    <div className="trade-item__col">
                      <span className="trade-item__info-title">
                        Supplied (HR)
                      </span>
                      <span className="trade-item__info-value">
                        {asset.contract.address !=
                        "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                          ? asset.contract.address !=
                              "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                            asset.contract.address !=
                              "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                            ? removeDecimal(
                                ethers.utils.formatEther(
                                  asset.ahrBalanceInAsset
                                ) * 1000
                              ) / (1000).toString()
                            : ethers.utils.formatEther(
                                asset.ahrBalanceInAsset
                              ) * (10000000000).toString()
                          : removeDecimal(
                              ethers.utils.formatUnits(
                                asset.ahrBalanceInAsset,
                                6
                              ) * 1000
                            ) / (1000).toString()}
                      </span>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="trade-item__info">
                      <div className="trade-item__col">
                        <span className="trade-item__info-title">APR</span>
                        <span className="trade-item__info-value">
                          {removeDecimal(
                            ethers.utils.formatEther(asset.borrowApy) * 100
                          ) / (100).toString()}
                          %
                        </span>
                      </div>
                      <div className="trade-item__col">
                        <span className="trade-item__info-title">
                          Liquidity (LR)
                        </span>
                        <span className="trade-item__info-value">
                          {asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                            ? asset.contract.address !=
                                "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                              asset.contract.address !=
                                "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                              ? removeDecimal(
                                  ethers.utils.formatEther(asset.liquidityLR) *
                                    1000
                                ) / (1000).toString()
                              : ethers.utils.formatEther(asset.liquidityLR) *
                                (10000000000).toString()
                            : removeDecimal(
                                ethers.utils.formatUnits(asset.liquidityLR, 6) *
                                  1000
                              ) / (1000).toString()}
                        </span>
                      </div>
                      <div className="trade-item__col">
                        <span className="trade-item__info-title">
                          Liquidity (HR)
                        </span>
                        <span className="trade-item__info-value">
                          {asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                            ? asset.contract.address !=
                                "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                              asset.contract.address !=
                                "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                              ? removeDecimal(
                                  ethers.utils.formatEther(asset.liquidityHR) *
                                    1000
                                ) / (1000).toString()
                              : ethers.utils.formatEther(asset.liquidityHR) *
                                (10000000000).toString()
                            : removeDecimal(
                                ethers.utils.formatUnits(asset.liquidityHR, 6) *
                                  1000
                              ) / (1000).toString()}
                        </span>
                      </div>
                      <div className="trade-item__col">
                        <span className="trade-item__info-title">
                          Borrowing
                        </span>
                        <span className="trade-item__info-value">
                          {asset.contract.address !=
                          "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                            ? removeDecimal(
                                ethers.utils.formatEther(asset.borrowBalance) *
                                  1000
                              ) / (1000).toString()
                            : removeDecimal(
                                ethers.utils.formatUnits(
                                  asset.borrowBalance,
                                  6
                                ) * 1000
                              ) / (1000).toString()}
                        </span>
                      </div>
                    </div>
                    <div className="modal-form__item recollateralize__table">
                      <div className="r-table">
                        <div className="r-table__list">
                          {asset.listTable.map((item) => (
                            <div className="r-table__row" key={item.id}>
                              <div className="r-table__col">
                                <span className="r-table__type">
                                  {item.type}
                                </span>
                                <InfoButton className="r-table__info">
                                  {item.info}
                                </InfoButton>
                                <InfoButtonMobile text={item.info} />
                              </div>
                              <div className="r-table__col">
                                <div className="r-table__percent">
                                  {item.ratio}%
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="trade-item__footer">
                  <div className="trade-item__wallet">
                    <span className="trade-item__wallet-title">
                      Wallet Balance
                    </span>
                    <div className="trade-item__wallet-value">
                      {asset.contract.address !=
                      "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
                        ? asset.contract.address !=
                            "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D" &&
                          asset.contract.address !=
                            "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                          ? removeDecimal(
                              ethers.utils.formatEther(asset.balance) * 1000
                            ) / (1000).toString()
                          : ethers.utils.formatEther(asset.balance) *
                            (10000000000).toString()
                        : removeDecimal(
                            ethers.utils.formatUnits(asset.balance, 6) * 1000
                          ) / (1000).toString()}
                    </div>
                  </div>

                  {tradeType === "lend" ? (
                    <>
                      <div className="trade_item_live">
                        {(tradeType === "lend") & asset.isInactive
                          ? "Coming Soon"
                          : "Live"}
                      </div>
                      <button
                        className="trade-item__btn"
                        onClick={() => dispatch(tradeLend({ asset: asset }))}
                      >
                        Supply/Withdraw
                      </button>
                    </>
                  ) : (
                    <button
                      className="trade-item__btn"
                      onClick={() =>
                        dispatch(tradeBorrow({ asset: asset, assets: data }))
                      }
                    >
                      Borrow / Repay / Loan Status
                    </button>
                  )}
                </div>
              </li>
            ))
          : null}
      </ul>
    </div>
  );
}
